
export default {
  parametros: {}
}
